// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { isVariantEnabled, makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForRange = makeThemedStyles('Range', () => ({
  Range: {
    margin: '1em',
    background: '#a1c0c3',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    padding: '0.7em',
    textTransform: 'capitalize',
    color: '#216871'
  },

  active: {
    borderBottom: '2px solid #333'
  },
  disabled: {
    backgroundColor: '#e3eced'
  },
  shadow: {
    boxShadow: '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)'
  },
  rounded: {
    borderRadius: '7px'
  },
  smallRounded: {
    borderRadius: '1em',
    padding: '0.4em',
    fontSize: '10px',
    justifyContent: 'space-evenly'
  },
  circleLarge: {},
  transparent: {
    background: 'none'
  },
  uppercase: {
    textTransform: 'uppercase'
  },
  white: {
    background: 'white',
    color: '#858a8d'
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const Range: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForRange();

  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.Range, {
        [styles.active]: isVariantEnabled(props, 'active'),
        [styles.disabled]: isVariantEnabled(props, 'disabled'),
        [styles.shadow]: isVariantEnabled(props, 'shadow'),
        [styles.rounded]: isVariantEnabled(props, 'rounded'),
        [styles.smallRounded]: isVariantEnabled(props, 'smallRounded'),
        [styles.circleLarge]: isVariantEnabled(props, 'circleLarge'),
        [styles.transparent]: isVariantEnabled(props, 'transparent'),
        [styles.uppercase]: isVariantEnabled(props, 'uppercase'),
        [styles.white]: isVariantEnabled(props, 'white')
      })}
    >
      {props?.children}
    </div>
  );
};
export default Range;
